import React from "react";
import { Box, useTheme } from "@mui/material";

type Props = {
  type: "VEG" | "NON_VEG";
  size?: number;
};

function VegNonVegIcon({ type, size = 16 }: Props) {
  const theme = useTheme();
  const borderColor = type === "VEG" ? theme.palette.success.main : theme.palette.error.main;
  const innerSize = Math.max(6, Math.round(size * 0.5));

  return (
    <Box
      sx={{
        width: size,
        height: size,
        boxSizing: "border-box",
        border: `1.5px solid ${borderColor}`,
        borderRadius: "2px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        lineHeight: 0,
      }}
      aria-hidden
    >
      {type === "VEG" ? (
        <Box
          sx={{
            width: innerSize,
            height: innerSize,
            borderRadius: "50%",
            backgroundColor: borderColor,
          }}
        />
      ) : (
        <Box
          sx={{
            width: 0,
            height: 0,
            borderLeft: `${Math.round(innerSize / 2)}px solid transparent`,
            borderRight: `${Math.round(innerSize / 2)}px solid transparent`,
            borderBottom: `${innerSize}px solid ${borderColor}`,
            transform: "translateY(1px)",
          }}
        />
      )}
    </Box>
  );
}

export default VegNonVegIcon;

